/* Subscribes a Globo form submitter to MailerLite, but only when they tick the
   consent checkbox. The forms are the app's markup, so this finds the fields by
   their labels rather than by ids the app might change:
     email    - an email input, or one labelled Email / Optional Email
     consent  - a checkbox whose label mentions the Toni and Ryan emails
   Globo submits over AJAX from a button click, so this listens for that click in
   the capture phase and reads the values before the app clears the form.
   Config comes from window.TARP_ML, emitted in theme.liquid from Theme settings.
   Never blocks or delays the submission: a MailerLite failure is logged only. */
(function () {
  var cfg = window.TARP_ML || {};
  // Proxy only now: the key used to be published here, which put a token
  // reaching every subscriber record into public page source.
  if (!cfg.proxy) return;

  var CONSENT_RE = /toni\s*and\s*ryan\s*emails?|sign\s*up/i;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var sent = {};

  function labelTextFor(input) {
    var wrap = input.closest('.globo-form-control, .globo-form-group, label, div');
    return wrap ? (wrap.textContent || '').trim() : '';
  }

  function findEmail(scope) {
    var direct = scope.querySelector('input[type="email"]');
    if (direct && direct.value) return direct.value.trim();
    var inputs = scope.querySelectorAll('input[type="text"], input:not([type])');
    for (var i = 0; i < inputs.length; i++) {
      if (/email/i.test(labelTextFor(inputs[i])) && inputs[i].value) {
        return inputs[i].value.trim();
      }
    }
    return direct ? (direct.value || '').trim() : '';
  }

  function consentGiven(scope) {
    var boxes = scope.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < boxes.length; i++) {
      if (CONSENT_RE.test(labelTextFor(boxes[i]))) return boxes[i].checked;
    }
    return false;
  }

  function subscribe(email, formId) {
    var dedupe = formId + '|' + email;
    if (sent[dedupe]) return;
    sent[dedupe] = true;

    var groups = [];
    if (cfg.group) groups.push(String(cfg.group));

    fetch(cfg.proxy, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        groups: groups,
        fields: formId ? { source: 'website form ' + formId } : undefined
      })
    })
      .then(function (res) {
        if (!res.ok && window.console) console.warn('MailerLite responded', res.status);
      })
      .catch(function (err) {
        if (window.console) console.warn('MailerLite subscribe failed', err);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '.globo-form-app button[type="submit"], .globo-form-app .wizard__submit, .globo-form-app .classic-button'
    );
    if (!btn) return;
    var scope = btn.closest('.globo-form-app');
    if (!scope) return;
    if (!consentGiven(scope)) return;

    var email = findEmail(scope);
    if (!EMAIL_RE.test(email)) return;

    var holder = scope.querySelector('.globo-formbuilder, [class*="globo-form-id-"]');
    var formId = '';
    if (holder) {
      var m = (holder.className || '').match(/globo-form-id-(\d+)/);
      formId = m ? m[1] : (holder.getAttribute('data-id') || '');
    }
    subscribe(email, formId);
  }, true);
})();
